'use client';
import { useEffect, useRef } from 'react';
import type { ReactNode, CSSProperties } from 'react';

export function CollapseIfEmpty({
  children,
  style,
  className,
}: {
  children: ReactNode;
  style?: CSSProperties;
  className?: string;
}) {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const hasContent =
      el.querySelector('[data-has-content]') ||
      (el.textContent?.trim().length ?? 0) > 0 ||
      el.querySelector('img, video, canvas, svg, iframe');
    el.style.display = hasContent ? '' : 'none';
  });

  return (
    <div ref={ref} style={style} className={className}>
      {children}
    </div>
  );
}
